import { useState } from 'react';
import styles from './../../../core/style/ImageLoader.module.css';

const ImageLoader = ({ src, alt, ratio = '16/9' }) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  return (
    <div 
      className={styles.container} 
      style={{ aspectRatio: ratio }}
      aria-busy={!hasLoaded}
    >
      {!hasLoaded && <div className={styles.shimmer} aria-hidden="true" />}
      <img
        src={src}
        alt={alt}
        className={`${styles.image} ${hasLoaded ? styles.isLoaded : styles.isHidden}`}
        onLoad={() => setHasLoaded(true)}
        loading="lazy" 
      />
    </div>
  );
};

export default ImageLoader;